import { IKIBusinessPriority } from 'legacy/lut/features/partner360/jbpSettings/models/kiBusinessPriority'

import { KeyInitiative } from 'partner360/entities/keyInitiatives'
import {
  buildBusinessPriorityUidToNameMap,
  getInitiativeBusinessPriorityNames,
} from 'partner360/features/mdfActivities/helpers/activityBusinessPriorities'
import { IMdfActivity } from 'partner360/features/mdfActivities/model/types'

export const getBusinessPrioritiesFromInitiatives = (
  activities: IMdfActivity[],
  initiatives: KeyInitiative[],
  kiBusinessPriorities: IKIBusinessPriority[]
): { key: string; label: string }[] => {
  const linkedInitiativeIds = new Set(
    activities.map((activity) => activity.keyInitiativeId).filter((id): id is number => id != null)
  )

  const uidToName = buildBusinessPriorityUidToNameMap(kiBusinessPriorities)

  const names = new Set(
    initiatives
      .filter((initiative) => linkedInitiativeIds.has(initiative.EntryId))
      .flatMap((initiative) => getInitiativeBusinessPriorityNames(initiative, uidToName))
  )

  return Array.from(names)
    .sort((a, b) => a.localeCompare(b))
    .map((name) => ({ key: name, label: name }))
}
